import http from 'plugins/axios';

export default {

  getAppInfo(platform) {
    return http.get({
      url: `/admin/app/package/${platform}`,
      dataType: 'form'
    });
  },

  getInfoList(data) {
    return http.get({
      url: '/admin/app/versionList',
      data
    })
  },

  updateInfo(data) {
    return http.post({
      url: '/admin/app/update',
      dataType: 'form',
      data
    })
  },

  removeInfo(data) {
    return http.post({
      url: '/admin/app/remove',
      dataType: 'form',
      data
    })
  },

  getNewestVersion(){
    return http.get({
      url: '/admin/app/newestVersion',
      dataType: 'form'
    })
  }
};
